import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Calendar = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.75 22.9167H14.5833V27.0834H18.75V22.9167ZM27.0833 22.9167H22.9167V27.0834H27.0833V22.9167ZM35.4167 22.9167H31.25V27.0834H35.4167V22.9167ZM39.5833 8.33335H37.5V4.16669H33.3333V8.33335H16.6667V4.16669H12.5V8.33335H10.4167C8.10417 8.33335 6.27083 10.2084 6.27083 12.5L6.25 41.6667C6.25 43.9584 8.10417 45.8334 10.4167 45.8334H39.5833C41.875 45.8334 43.75 43.9584 43.75 41.6667V12.5C43.75 10.2084 41.875 8.33335 39.5833 8.33335ZM39.5833 41.6667H10.4167V18.75H39.5833V41.6667Z"
        fill={color}
      />
    </svg>
  )
}
